import { EquipmentDTO } from "./Equipment.model";
import { DomSanitizer,SafeResourceUrl  } from '@angular/platform-browser';

export class ProcedureDTO {
    ID: string;
    DuplicateSharedProcedureID:string;
    ProcedureSource:number;
    SharedByUserID:number;
    Name: string;
    SpecialityID: number;
    SpecialityName: string;
    UserID: number;
    Description: string;
    Equipments:Array<EquipmentDTO>;
}

export class TemplateDTO {
    Images: Array<ImageDTO>;
    CheckList: Array<CheckListDTO>
    Videos: Array<VideoDTO>;
}

export class ImageDTO {
    Name: string;
    ImagePath: string;
    ImageBase64:string
}

export  class  DeleteImageDTO
{
    Image: ImageDTO;
    SpecialityId :number;
    ProcedureId:string;
}

export class CheckListDTO {
    StepNo: number;
    Description: string;
}

export  class  DeleteCheckListDTO
{
    CheckList: CheckListDTO;
    SpecialityId :number;
    ProcedureId:string;
}

export class VideoDTO {
    Name: string;
    VideoUrl: string;
}

export  class  DeleteVideoDTO
{
    Video: VideoDTO;
    SpecialityId :number;
    ProcedureId:string;
}

export class SafeVideoDTO {
    Name: string;
    SafeVideoUrl: SafeResourceUrl;
}

export class AssignedProcedureDTO {
    UserId: number;
    SpecialityId: number;
    ProcedureId: string;
    Description:string;
    Name:string;
    IsChecked:boolean;
    disableAssigned:boolean;
}


export class UserProcedureDataDTO {
    UserId: number;
    SpecialityId: number;
    ProcedureId: string;
    Template: TemplateDTO
    Equipments: Array<EquipmentDTO>
}

export enum ProcedureOrigin {
    Assigned,
    Shared,
    Created,
    SharedDuplicate
}

export class CustomProcedureDTO{
  SpecialityId:number;
  ProcedureName:string;
}

export class SpecialityImageDTO{
    SpecialityId:number;
    ImageBase64:string;
    ImagePath:string;

}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Procedure.model.ts